var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { buildBorderProps, buildSpacingProps } from '../../helpers/builders';
import { isString } from '../../utils/assertion';
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  height: ", ";\n  background: ", ";\n\n  ", "\n  ", ";\n"], ["\n  display: inline-flex;\n  align-items: center;\n  height: ", ";\n  background: ", ";\n\n  ", "\n  ", ";\n"])), function (_a) {
    var height = _a.height;
    return (isString(height) ? height : "".concat(height, "px"));
}, function (_a) {
    var bgColor = _a.bgColor;
    return bgColor;
}, buildBorderProps, buildSpacingProps);
var templateObject_1;
